import React, { useState } from 'react'
import {Box,Paper,Button, Typography, TextField, CircularProgress, colors } from '@mui/material'
import { Cancel, DeckOutlined, ImportContactsSharp } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';

export default function ClaimListItem({k,proveClaim}) {

    const [value,setValue]=useState(null)
    const [loadingClaim,setLoadingClaim]=useState(false)
    const [ans,setAns]=useState(null)
    return (<Paper elevation={5} sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:{xs:"90vw",md:"75vw"},minHeight:"12vh",marginTop:"2vh"}}>
      <Typography sx={{width:{xs:"85vw",md:"70vw"}}}>Verify {k}</Typography>
      <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-around",width:"70vw"}}>
        
        <TextField variant='outlined' label={k} sx={{width:{xs:"50vw",md:"40vw"}}} onChange={(e)=>setValue(e.target.value)} color="primary">Verify {k}</TextField>
        <Button variant="contained" sx={{fontSize:"18px",width:{xs:"15vw",md:"10vw"}}} onClick={async ()=>{
          setLoadingClaim(true)
          console.log(k,value)
          setAns(await proveClaim(k,value))
          console.log("ANS ",ans)
          setLoadingClaim(false)
        }}>Verify</Button>
        <Box sx={{width:{xs:"10vw",md:"15vw"}}}>
          {loadingClaim? <CircularProgress color="primary"/>:<></>}
          {(ans && <span><DoneIcon color="success"/> <Typography color="success">Verified</Typography></span>)}
          {(ans==false && <span><Cancel sx={{color:"#ff1744"}}/><Typography sx={{color:"#ff1744"}}>Invalid</Typography></span>)}
        </Box>
        <Typography>{ans}</Typography>
      </Box>
    </Paper>)
}
